// extracted by mini-css-extract-plugin
export var configurationSection = "_sm-0";